import styled, { css } from 'styled-components'

interface IconProps {
  round?: boolean
  unlockedProportions?: boolean
  color?: string
  useIconColor?: boolean
}

export const Icon = styled.i<IconProps>`
  display: inline-flex;
  flex-shrink: 0;
  justify-content: center;
  align-items: center;
  font-size: ${({ theme }) => theme.styledVariant('size', {
    small: theme.rem(12),
    medium: theme.rem(14),
    default: theme.rem(16),
    big: theme.rem(24),
    huge: theme.rem(32),
    large: theme.rem(48),
  })};

  svg {
    width: 1em;
    height: 1em;

    ${({ unlockedProportions }) => unlockedProportions && css`
        height: 1em;
        width: auto;
    `}
  }

  path {
    transition: all 0.2s ease-in 0s;
    ${({ useIconColor, color = 'currentColor' }) => !useIconColor && css`
      fill: ${color};
    `}
  }

  ${({ round, theme }) => round && css`
    padding: ${theme.rem(8)};
    background-color: white;
    border-radius: 50%;
  `}
`
